export default class BatchCreateLetterDraft {
    static ACTION_NAME = 'CreateLetterDraft';

    constructor() {
        this.action = BatchCreateLetterDraft.ACTION_NAME;
        this.entity = 'ClubDog';
        this.subject = '';
    }

    serialize() {
        return {
            action: this.action,
            entity: this.entity,
            ids: this.ids,
            draftId: this.draft.id,
            clubFeeId: this.clubFee.id,
            sendLetter: this.sendLetter,
            subject: this.subject,
            senderEmail: this.senderEmail?.email,
            message: this.message,
        };
    }

    isValid() {
        if (!this.ids || this.ids.length === 0) {
            return false;
        }
        if (!this.draft) {
            return false;
        }
        if (!this.clubFee) {
            return false;
        }
        if (this.sendLetter && (!this.senderEmail || !this.subject)) {
            return false;
        }
        return true;
    }
}
